import React from 'react'
import type { DrawerProps as MuiDrawerProps } from '@material-ui/core/Drawer'
import MuiDrawer from '@material-ui/core/Drawer'

export type DrawerProps = MuiDrawerProps

const Drawer = React.forwardRef<HTMLDivElement, DrawerProps>(function Drawer(props, ref) {
  return <MuiDrawer ref={ref} {...props} />
})

export default Drawer
